import React from "react";
import { Link as ScrollLink } from "react-scroll";

const herosectionData = {
  name: "Mahdi Saleh",
  aboutMe:
    "I am Mehdi Saleh, a 1997-born Accounting graduate with experience in IT as a System Administrator and WordPress Administrator. I have hands-on knowledge of Linux, networking, and DevOps tools like Docker, Kubernetes, Grafana, and CI/CD pipelines. I am passionate about starting my career as a DevOps Engineer and applying my skills to professional projects.",
};

function Herosection() {
  return (
    <section
      className="hero background parallax shadow-dark d-flex align-items-center"
      
    >
      <div className="cta mx-auto mt-2">
        <h1 className="mt-0 mb-4">
          I’m {herosectionData.name}
          <span className="dot"></span>
        </h1>
        <p className="mb-4">{herosectionData.aboutMe}</p>
        <ScrollLink
          activeClass="active"
          to="section-experiences"
          spy={true}
          smooth={true}
          duration={500}
          offset={50}
          className="btn btn-default btn-lg mr-3"
        >
          <i className="icon-grid"></i>View Experiences
        </ScrollLink>
        <div
          className="spacer d-md-none d-lg-none d-sm-none"
          data-height="10"
        ></div>
        <ScrollLink
          activeClass="active"
          to="section-contact"
          spy={true}
          smooth={true}
          duration={500}
          offset={50}
          className="btn btn-border-light btn-lg"
        >
          <i className="icon-envelope"></i>Hire me
        </ScrollLink>
      </div>
      <div className="overlay"></div>
    </section>
  );
}

export default Herosection;
